import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { accountCheck } from "../../services/eventService";

const initialState = {
  paymentGetway: {
    loading: true,
    connect: false,
    error: null,
  },
};

export const checkPaymentGateway = createAsyncThunk(
  "paymentConnect/checkPaymentGateway",
  async ({ userId }, { rejectWithValue }) => {
    try {
      const res = await accountCheck({ user: userId });
      if (res?.data?.status === 200) {
        return res?.data;
      } else {
        return rejectWithValue(res?.data?.message || "Something went wrong");
      }
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  }
);

const paymentAccountConnectSlice = createSlice({
  name: "paymentConnect",
  initialState,
  reducers: {
    setPaymentGatewayConnect: (state, action) => {
      state.paymentGetway.connect = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkPaymentGateway.pending, (state) => {
        state.paymentGetway.loading = true;
        state.paymentGetway.connect = false;
      })
      .addCase(checkPaymentGateway.fulfilled, (state, action) => {
        state.paymentGetway.loading = false;
        state.paymentGetway.connect =
          action?.payload?.data?.stripe || action?.payload?.data?.paypal;
      })
      .addCase(checkPaymentGateway.rejected, (state, action) => {
        state.paymentGetway.loading = false;
        state.paymentGetway.connect = false;
        state.paymentGetway.error = action.payload;
      });
  },
});

export const { setPaymentGatewayConnect } = paymentAccountConnectSlice?.actions;
export default paymentAccountConnectSlice?.reducer;
